import React from "react";
import { faDownload, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Table, TableTr, TableTh, TableTd, ButtonIcon } from "ui-kit-sahadevia";

import ModalInvoice from "./ModalInvoice";

import { getPrice } from "../../utils/general";

export default class Invoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idxModalInvoice: null,
    };
  }

  render() {
    return (
      <>
        <div
          className="overflow-y"
          style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
        >
          <Table
            title="Factures"
            thead={
              <TableTr>
                <TableTh>#</TableTh>
                <TableTh>Nom</TableTh>
                <TableTh>Montant</TableTh>
                <TableTh>Date d'ajout</TableTh>
                <TableTh>Date</TableTh>
                <TableTh>Type</TableTh>
                <TableTh>Actions</TableTh>
              </TableTr>
            }
            tbody={this.props.invoices.map((element, idx) => (
              <TableTr key={idx}>
                <TableTh>
                  <span
                    style={{
                      backgroundColor: element.type ? "#2ECC71" : "#E74C3C",
                      color: "#ffffff",
                      padding: "0.6rem",
                      borderRadius: "8px",
                    }}
                  >
                    {idx + 1}
                  </span>
                </TableTh>
                <TableTd>{element.name}</TableTd>
                <TableTd>{getPrice(element.price)}</TableTd>
                <TableTd>{element.dateInsert}</TableTd>
                <TableTd>{element.date}</TableTd>
                <TableTd>{element.type ? "Vente" : "Achat"}</TableTd>
                <TableTd className="nowrap">
                  <ButtonIcon
                    icon={faTrash}
                    onClick={() => this.props.deleteInvoice(element.id)}
                  />
                  <ButtonIcon
                    icon={faPen}
                    onClick={() => {
                      this.setState({
                        idxModalInvoice: idx,
                      });
                    }}
                  />
                  <ButtonIcon
                    icon={faDownload}
                    onClick={() => this.props.downloadInvoice(element.id)}
                  />
                </TableTd>
              </TableTr>
            ))}
          />
        </div>
        <ModalInvoice
          title="Modifier une facture"
          show={this.state.idxModalInvoice !== null}
          data={
            this.state.idxModalInvoice !== null
              ? this.props.invoices[this.state.idxModalInvoice]
              : {}
          }
          isUpdate={true}
          onClose={(isReload) =>
            this.setState(
              {
                idxModalInvoice: null,
              },
              () => {
                if (isReload) {
                  this.props.getInvoices();
                }
              }
            )
          }
        />
      </>
    );
  }
}
